import React from 'react';
import { useSelector } from 'react-redux';
import {
    DashboardTicketsChartsGrid,
    DashboardTicketsDashboardSkeleton,
    DashboardTicketsFiltersDrawer,
    DashboardTicketsSummaryCards,
    DashboardTicketsVariationCards,
} from './components';
import { useDashboardTickets } from './hooks/useDashboardTickets';

export const DashboardTicketsScreen = () => {
    const { token } = useSelector((state) => state.auth);

    const {
        isLoading,
        isBusy,
        error,
        dashboard,
        days,
        setDays,
        dateFrom,
        setDateFrom,
        dateTo,
        setDateTo,
        status,
        setStatus,
        priority,
        setPriority,
        type,
        setType,
        source,
        setSource,
        slaMode,
        setSlaMode,
        assigneeId,
        setAssigneeId,
        assigneeOptions,
        isFiltersDrawerOpen,
        setIsFiltersDrawerOpen,
        quickRangeOptions,
        statusOptions,
        priorityOptions,
        typeOptions,
        sourceOptions,
        slaModeOptions,
        hasActiveFilters,
        trendSeriesCreated,
        trendSeriesResolved,
        trendPointsCreated,
        trendPointsResolved,
        formatNumber,
        formatHours,
        formatVariation,
        variationClass,
        handleClearFilters,
        loadDashboard,
        handleExportExcel,
        handleExportPdf,
    } = useDashboardTickets({ token });

    return (
        <div className="row">
            <div className="col-12">
                <div className="card stretch stretch-full card__no-border">
                    <div className="card-body">
                        <div className="d-flex flex-wrap align-items-center justify-content-between mb-3 gap-2">
                            <div>
                                <h4 className="mb-1">Dashboard de tickets</h4>
                                <p className="text-muted mb-0 fs-12">Vista operativa: cumplimiento SLA, tiempos de atención y salud del backlog.</p>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                {hasActiveFilters && <span className="badge bg-soft-warning text-warning">Filtros activos</span>}
                                <button
                                    type="button"
                                    className="btn btn-sm btn-light"
                                    onClick={handleExportExcel}
                                    disabled={isBusy}
                                >
                                    <i className="feather-file-text me-1" />
                                    Excel
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-light"
                                    onClick={handleExportPdf}
                                    disabled={isBusy}
                                >
                                    <i className="feather-printer me-1" />
                                    PDF
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-light-brand"
                                    onClick={() => setIsFiltersDrawerOpen(true)}
                                    disabled={isBusy}
                                >
                                    <i className="feather-sliders me-1" />
                                    Filtros
                                </button>
                            </div>
                        </div>

                        <DashboardTicketsFiltersDrawer
                            isOpen={isFiltersDrawerOpen}
                            onClose={() => setIsFiltersDrawerOpen(false)}
                            days={days}
                            quickRangeOptions={quickRangeOptions}
                            onDaysChange={setDays}
                            dateFrom={dateFrom}
                            dateTo={dateTo}
                            onDateFromChange={setDateFrom}
                            onDateToChange={setDateTo}
                            status={status}
                            statusOptions={statusOptions}
                            onStatusChange={setStatus}
                            priority={priority}
                            priorityOptions={priorityOptions}
                            onPriorityChange={setPriority}
                            type={type}
                            typeOptions={typeOptions}
                            onTypeChange={setType}
                            source={source}
                            sourceOptions={sourceOptions}
                            onSourceChange={setSource}
                            assigneeId={assigneeId}
                            assigneeOptions={assigneeOptions}
                            onAssigneeChange={setAssigneeId}
                            slaMode={slaMode}
                            slaModeOptions={slaModeOptions}
                            onSlaModeChange={setSlaMode}
                            onApply={loadDashboard}
                            onClear={handleClearFilters}
                            isLoading={isBusy}
                        />

                        {error && <div className="alert alert-danger py-2 mb-3">{error}</div>}

                        {isLoading && <DashboardTicketsDashboardSkeleton />}

                        {!isLoading && (
                            <>
                                <DashboardTicketsSummaryCards
                                    summary={dashboard?.summary}
                                    formatNumber={formatNumber}
                                    formatHours={formatHours}
                                />
                                <DashboardTicketsVariationCards
                                    summary={dashboard?.summary}
                                    previousSummary={dashboard?.previousSummary}
                                    variation={dashboard?.variation}
                                    formatNumber={formatNumber}
                                    formatVariation={formatVariation}
                                    variationClass={variationClass}
                                />
                                <DashboardTicketsChartsGrid
                                    dashboard={dashboard}
                                    trendSeriesCreated={trendSeriesCreated}
                                    trendSeriesResolved={trendSeriesResolved}
                                    trendPointsCreated={trendPointsCreated}
                                    trendPointsResolved={trendPointsResolved}
                                    formatNumber={formatNumber}
                                />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
